module.exports = __webpack_public_path__ + "static/media/sound1.c3428b40.mp3";